module.exports = __webpack_public_path__ + "media/images/homes/arrow_150-d2af03a4c55c68c98729322fd6d228c7.png";